import {
  AddOrganisationCard,
  AssignResponsibleOwnerModal,
  Column,
  ErrorBox,
  ProjectAccessRollupTable,
  Row,
} from "../../../../../widget";
import { useProjectAccessStep } from "./useProjectAccessStep";

export const ProjectAccessStep = (): JSX.Element => {
  const {
    variant,
    corners,
    organisationTypeOptions,
    organisationOptions,
    accessOptions,
    projectOptions,
    selection,
    rollupRows,
    rollupResetKey,
    responsibleOwnerOptions,
    existingDeveloperPrompts,
    existingDeveloperActionOptions,
    cardErrors,
    saveErrors,
    isSaving,
    isPreviousDisabled,
    showAssignResponsibleOwnerModal,
    handleSelectionChange,
    handleOrganisationSearch,
    handleAdd,
    handleRemoveOrganisation,
    handleResponsibleOwnerChange,
    handleConfirmResponsibleOwner,
    handleCancelResponsibleOwner,
    handlePrevious,
    handleSave,
  } = useProjectAccessStep();

  return (
    <div className="ProjectAccessStep">
      {saveErrors.length > 0 && (
        <Row spacingV="ml">
          <Column span={12}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={saveErrors.map((error) => error.message ?? error.code)}
            />
          </Column>
        </Row>
      )}

      <Row>
        <Column span={12}>
          <ProjectAccessRollupTable
            key={rollupResetKey}
            rows={rollupRows}
            corners={corners}
            variant={variant}
            addOrganisation={
              <AddOrganisationCard
                organisationTypeOptions={organisationTypeOptions}
                organisationOptions={organisationOptions}
                accessOptions={accessOptions}
                projectOptions={projectOptions}
                value={selection}
                onChange={handleSelectionChange}
                onOrganisationSearch={handleOrganisationSearch}
                onAdd={handleAdd}
                errors={cardErrors}
                corners={corners}
                existingDeveloperPrompts={existingDeveloperPrompts}
                existingDeveloperActionOptions={existingDeveloperActionOptions}
              />
            }
            responsibleOwnerOptions={responsibleOwnerOptions}
            onResponsibleOwnerChange={handleResponsibleOwnerChange}
            onRemoveOrganisation={handleRemoveOrganisation}
            onPrevious={handlePrevious}
            isPreviousDisabled={isPreviousDisabled}
            onSave={handleSave}
            isLoading={isSaving}
          />
        </Column>
      </Row>

      <AssignResponsibleOwnerModal
        show={showAssignResponsibleOwnerModal}
        onConfirm={handleConfirmResponsibleOwner}
        onCancel={handleCancelResponsibleOwner}
      />
    </div>
  );
};
